// lender details
export enum OFFERID {
  AFS = '02JSNoMeC0',
  ANGLE = 'is6I365uCH',
  ANGLE_NOVATED = 'iP3758KtIE',
  ANZ = 'aPRn8iY2O0',
  FINANCE_ONE = 'Az3YDHse0A',
  FINANCE_ONE_C = 'dzKGYHse0V',
  FINANCE_ONE_PL = 'rZM8cNNz66',
  FIRST_MAC = 'OlTG1D1duY',
  SHIFT_COMMERCIAL = '2vJt0g7HEz',
  GROW = 'Oyy1tfaR8L',
  GROW_CONSUMER = '3yO0eeFq43',
  LATITUDE = 'f8mMpX74V8',
  LIBERTY = 'X1L1y4JeEd',
  LIBERTY_C = 'UV9ha32YFK',
  MACQUARIE = 'mC24vZk133',
  MACQUARIE_C = 'emg5SLYv5h',
  METRO = 'v53tLO8QQg',
  MONEY_THREE = 'qGJshSoAjl',
  MONEY_THREE_PL = '76bkvefz1T',
  MONEY_PLACE = 'fd9aR68Yxi',
  MONEY_PLACE_PL = 'a87Gaks8f7',
  NOW_FINANCE = 'm6iE8b4MqL',
  NOW_FINANCE_PL = 'jmcB55yOS4',
  NOW_FINANCE_RO_PL = 'L7IAvFnYfs',
  PEPPER = 'QB67dG9meu',
  PEPPER_C = 'p775l2K6Mw',
  PROSPA = 'J0Zul3cv9o',
  RATE_SETTER = 'bCn3AoOa0w',
  RATE_SETTER_PL = 'b6eNE0u2kG',
  SOCIETY_ONE = 't2RWwThRe8',
  ST_GEORGE = 'KPwf3UHbG3',
  WESTPAC = 'vD29PCatS7',
  WISR = 'Y0fEMThmvQ',
  WISR_PL = 'iJmGjG4wfO',
  VOLKSWAGEN = 'bT4x42QcY5',
  BFS = 'fT4x48QcY7',
  AUTOPAY = 'nXk7tz10Ec',
  PLENTI_C = '2t3jrG69kF',
  AUTOPAY_C = 'e7yaQQT2ZL',
  LOAN_U = '6r2hrG96sB',
  LOAN_U_PL = 'f876ghJHGF',
  MONEYME_PL = 'Vmv8sfu6Du',
  GREEN_LIGHT_AUTO = '34oRO67cod',
  CAR_START = '0YdxZ8O0bk',
  MEDFIN = 'kJ3X0G636e',
  AMMF = 'up5WG646Ck',
  LATITUDE_PL = 'dkK9UxP05O',
  OUR_MONEY_MARKET_PL = 'bkA9U7vY7n',
  OUR_MONEY_MARKET_RO_PL = 'e5jJnibFY5',
  OUR_MONEY_MARKET_SECURED = 'ffA6U3vY7a',
  AFFORDABLE_CAR_LOANS = '5muWB5C5vB',
  ALEX_BANK = '43h7Th5TGQ',
  ALEX_BANK_SECURED = 'x759HWyNVE',
  FINANCE_ONE_PLATINUM = '3znEgbae8n',
  FAIR_GO_FINANCE = '6cH3MB863q',
  SALT_AND_LIME = 'zeB4JeSJ8R',
  METRO_CONSUMER = 'cHAMPjj86w',
  SALT_AND_LIME_SECURED = 'dV4QHsqbD4',
  RAPID_LOANS_PL = 'ax8wZu52Uv',
  JACARANDA_PL = 'w878TJa3cy',
  RAPID_LOANS = 'ux8wZb52Uc',
  AFS_VYRO = '9w2tfExjSe',
  CREDIT24_PL = '38kmnt7cag',
  METRO_NOVATED = '8uaqgqqPdR',
  AVANTI_FINANCE_PL = 'PZkTsbrT26',
  HEARTLAND_BANK = 'zABhjz9EkH',
  UDC_FINANCE = 'KX75sFsvJz',
  GEM_BY_LATITUDE = 'GfU5fd7zzh',
  FINANCE_NOW = 'ZZpSUJfzNv',
  FINANCE_NOW_PL = 'svJyjMMnTd',
  AZORA_COMMERCIAL = 'hkbCM0eAX3',
  RESIMAC_COMMERCIAL = 'j3aX0v5efg',
  PLENTI_RO_PL_FIXED = 'ghy6QSb624',
  LATITUDE_RO_PL = 'xYORM8Fq2X',
  FAIR_GO_FINANCE_RO_PL = 'k8Ko8RJYiR',
  CFS = '6qMqI7qtEK',
  GENEVA_FINANCE = 'PQ4qgcV8aR',
  GENEVA_FINANCE_PL = 'L09giNXuUM',
  AVANTI_FINANCE = 'zmSPKS2I3R',
  FHL = 'gP3qY9mZ2x',
  FHL_COMMERCIAL = 'gHx9mSXaMi',
  FHL_PL = '6mM2MyUwf4',
  UDC_FINANCE_COMMERCIAL = 'JJ6RczmOdu',
  AVANTI_FINANCE_COMMERCIAL = 'AY6gvAWS3M',
  HEARTLAND_BANK_COMMERCIAL = '7qL4UfHrjm',
  LUMI_COMMERCIAL = '4Gxy0hbNmX',
  FINANCE_ONE_PLUS = 'Rojq42kAcz',
  MTF_FINANCE = 'nMbSm7a7lc',
  OXFORD_FINANCE = 'jNT6vQOV6T',
  HEARTLAND_PL = 'nT46aBqBT1',
  TRUEPILLARS_COMMERCIAL = 'RAu63YzShC',
  FINANCE_ONE_PLUS_COMMERCIAL = 'ySx1cSMFye',
  SELFCO_COMMERCIAL = 'G53cQ4csQJ',
  REVOLUT_RO_PL = 'iV8SiXH8mE',
  PLENTI_RO_PL_VARIABLE = '76mjpBNUjg',
  WISR_RO_PL = 'FMKzqaG3ii',
  DRIVA_NOVATED = 'vilg3Dh7as',
  MONEYME_PL_PAYSLIP_ONLY = 'E8UKZobMFN',
  LIBERTY_NOVATED = 'oplRC6Vthz',
  THE_ASSET_FINANCIER_CONSUMER = '36zYmh2fXE',
  THE_ASSET_FINANCIER_COMMERCIAL = '937JbTLkR3',
  MONEYME_RO_PL = 'bunoPxT0Ge',
  ADVANTAGE_FINANCE = 'NDqZahSZJK',
  GO_CAR_CREDIT = 'BeDXPbHFvi',
  DYNA_MONEY = '2IRWYf17Xw',
  ALLIED_NOVATED = 'H3qZp7LwV9',
  ANGLE_AUTO = 'y8rJ4Dqp30',
  OXFORD_COMMERCIAL = 'S0drhFUf5Q',
  MORRIS_FINANCE_COMMERCIAL = 'dbBLzAfWwG',
  BIZCAP_COMMERCIAL = 'DQqAa2AFtP',
  OXFORD_PL = 'jdMJnW3R4U',
  GAMMA_DUO = 'hS0dRUHZcH',
  GAMMA_DUO_PL = 'IxOfN0YuFI',
  JACARANDA_RO_PL = 'z84vT0uUdu',
  ALEX_BANK_RO = 'nKDBjaQlC7',
  ALEX_BANK_RO_PL = 'gaSly1EHQY',
  AUTO_FINANCE_DIRECT = 'YBmgQBWF9A',
  HARMONEY = '53ejVoEo7s',
}

export enum LENDER {
  BFS = 'bfs',
  AFS = 'afs',
  ANGLE = 'angle',
  ANGLE_NOVATED = 'angleNovated',
  ANZ = 'anz',
  FINANCE_ONE = 'financeOne',
  FINANCE_ONE_C = 'financeOneC',
  FINANCE_ONE_PL = 'financeOnePl',
  FIRST_MAC = 'firstMac',
  SHIFT_COMMERCIAL = 'shiftCommercial',
  GROW = 'grow',
  GROW_CONSUMER = 'growConsumer',
  LATITUDE = 'latitude',
  LIBERTY = 'liberty',
  LIBERTY_C = 'libertyC',
  MACQUARIE = 'macquarie',
  MACQUARIE_C = 'macquarieC',
  METRO = 'metro',
  MONEY_THREE = 'moneyThree',
  MONEY_THREE_PL = 'moneyThreePl',
  MONEY_PLACE = 'moneyPlace',
  MONEY_PLACE_PL = 'moneyPlacePl',
  NOW_FINANCE = 'nowFinance',
  NOW_FINANCE_PL = 'nowFinancePl',
  NOW_FINANCE_RO_PL = 'nowFinanceRoPl',
  PEPPER = 'pepper',
  PEPPER_C = 'pepperC',
  PROSPA = 'prospa',
  RATE_SETTER = 'rateSetter',
  RATE_SETTER_PL = 'rateSetterPl',
  SOCIETY_ONE = 'societyOne',
  ST_GEORGE = 'stGeorge',
  WESTPAC = 'westpac',
  WISR = 'wisr',
  WISR_PL = 'wisrPl',
  VOLKSWAGEN = 'volkswagen',
  AUTOPAY = 'autopay',
  PLENTI_C = 'plentiC',
  AUTOPAY_C = 'autopayC',
  LOAN_U = 'loanU',
  LOAN_U_PL = 'loanUPl',
  MONEYME_PL = 'moneymePl',
  GREEN_LIGHT_AUTO = 'greenLightAuto',
  CAR_START = 'carStart',
  MEDFIN = 'medfin',
  AMMF = 'ammf',
  LATITUDE_PL = 'latitudePl',
  OUR_MONEY_MARKET_PL = 'ourMoneyMarketPl',
  OUR_MONEY_MARKET_RO_PL = 'ourMoneyMarketRoPl',
  OUR_MONEY_MARKET_SECURED = 'ourMoneyMarketSecured',
  AFFORDABLE_CAR_LOANS = 'affordableCarLoans',
  ALEX_BANK = 'alexBank',
  ALEX_BANK_SECURED = 'alexBankSecured',
  FINANCE_ONE_PLATINUM = 'FinanceOnePlatinum',
  FAIR_GO_FINANCE = 'FairGoFinance',
  SALT_AND_LIME = 'saltAndLime',
  METRO_CONSUMER = 'metroConsumer',
  SALT_AND_LIME_SECURED = 'saltAndLimeSecured',
  RAPID_LOANS_PL = 'rapidLoansPl',
  JACARANDA_PL = 'jacarandaPL',
  RAPID_LOANS = 'rapidLoans',
  AFS_VYRO = 'afsVyro',
  CREDIT24_PL = 'credit24Pl',
  METRO_NOVATED = 'metroNovated',
  AVANTI_FINANCE_PL = 'avantiFinancePl',
  HEARTLAND_BANK = 'heartlandBank',
  UDC_FINANCE = 'udcFinance',
  GEM_BY_LATITUDE = 'gemByLatitude',
  FINANCE_NOW = 'financeNow',
  FINANCE_NOW_PL = 'financeNowPl',
  AZORA_COMMERCIAL = 'azoraCommercial',
  RESIMAC_COMMERCIAL = 'resimacCommercial',
  PLENTI_RO_PL_FIXED = 'plentiRoPlFixed',
  LATITUDE_RO_PL = 'latitudeRoPl',
  FAIR_GO_FINANCE_RO_PL = 'FairGoFinanceRoPl',
  CFS = 'cfs',
  GENEVA_FINANCE = 'genevafinance',
  GENEVA_FINANCE_PL = 'genevafinancepl',
  AVANTI_FINANCE = 'avantiFinance',
  FHL = 'fhl',
  FHL_COMMERCIAL = 'fhlcommercial',
  FHL_PL = 'fhlPl',
  UDC_FINANCE_COMMERCIAL = 'udccommercial',
  AVANTI_FINANCE_COMMERCIAL = 'avantiFinanceCommercial',
  HEARTLAND_BANK_COMMERCIAL = 'heartlandBankCommercial',
  LUMI_COMMERCIAL = 'lumiCommercial',
  FINANCE_ONE_PLUS = 'financeOnePlus',
  MTF_FINANCE = 'mtfFinance',
  OXFORD_FINANCE = 'oxfordFinance',
  HEARTLAND_PL = 'heartlandPl',
  TRUEPILLARS_COMMERCIAL = 'truepillarsCommercial',
  FINANCE_ONE_PLUS_COMMERCIAL = 'finance1PlusCommercial',
  SELFCO_COMMERCIAL = 'selfcoCommercial',
  REVOLUT_RO_PL = 'revolutRoPl',
  PLENTI_RO_PL_VARIABLE = 'plentiRoPlVariable',
  WISR_RO_PL = 'wisrRoPl',
  DRIVA_NOVATED = 'drivaNovated',
  MONEYME_PL_PAYSLIP_ONLY = 'moneyMePlPayslipOnly',
  LIBERTY_NOVATED = 'libertyNovated',
  THE_ASSET_FINANCIER_CONSUMER = 'theAssetFinancierConsumer',
  THE_ASSET_FINANCIER_COMMERCIAL = 'theAssetFinancierCommercial',
  MONEYME_RO_PL = 'moneyMeRoPl',
  ADVANTAGE_FINANCE = 'advantageFinance',
  GO_CAR_CREDIT = 'goCarCredit',
  DYNA_MONEY = 'dynaMoney',
  ALLIED_NOVATED = 'alliedNovated',
  ANGLE_AUTO = 'angleAuto',
  OXFORD_COMMERCIAL = 'oxfordCommercial',
  MORRIS_FINANCE_COMMERCIAL = 'morrisFinanceCommercial',
  BIZCAP_COMMERCIAL = 'bizcapCommercial',
  OXFORD_PL = 'oxfordPl',
  GAMMA_DUO = 'gammaDuo',
  GAMMA_DUO_PL = 'gammaDuoPl',
  JACARANDA_RO_PL = 'jacarandaRoPl',
  ALEX_BANK_RO = 'alexBankRo',
  ALEX_BANK_RO_PL = 'alexBankRoPl',
  AUTO_FINANCE_DIRECT = 'autoFinanceDirect',
  HARMONEY = 'harmoney',
}

export const lenderOptions = Object.values(LENDER)

export type Lender = (typeof lenderOptions)[number]

export const lenderMap = {
  [LENDER.AFS]: 'AFS',
  [LENDER.ANGLE]: 'Angle',
  [LENDER.ANGLE_NOVATED]: 'Angle Novated',
  [LENDER.ANZ]: 'ANZ',
  [LENDER.FINANCE_ONE]: 'Finance One',
  [LENDER.FINANCE_ONE_C]: 'Finance One Commercial',
  [LENDER.FINANCE_ONE_PL]: 'Finance One PL',
  [LENDER.FIRST_MAC]: 'First Mac',
  [LENDER.SHIFT_COMMERCIAL]: 'Shift Commercial',
  [LENDER.GROW]: 'Grow',
  [LENDER.GROW_CONSUMER]: 'Grow Consumer',
  [LENDER.LATITUDE]: 'Latitude',
  [LENDER.LIBERTY]: 'Liberty',
  [LENDER.LIBERTY_C]: 'Liberty Commercial',
  [LENDER.MACQUARIE]: 'Macquarie',
  [LENDER.MACQUARIE_C]: 'Macquarie Commercial',
  [LENDER.METRO]: 'Metro',
  [LENDER.MONEY_THREE]: 'Money Three',
  [LENDER.MONEY_THREE_PL]: 'Money Three PL',
  [LENDER.MONEY_PLACE]: 'Money Place',
  [LENDER.MONEY_PLACE_PL]: 'Money Place PL',
  [LENDER.NOW_FINANCE]: 'NOW Finance',
  [LENDER.NOW_FINANCE_PL]: 'NOW Finance PL',
  [LENDER.NOW_FINANCE_RO_PL]: 'NOW Finance RO PL',
  [LENDER.PEPPER]: 'Pepper',
  [LENDER.PEPPER_C]: 'Pepper Commercial',
  [LENDER.PROSPA]: 'Prospa',
  [LENDER.RATE_SETTER]: 'Rate Setter',
  [LENDER.RATE_SETTER_PL]: 'Rate Setter PL',
  [LENDER.SOCIETY_ONE]: 'Society One',
  [LENDER.ST_GEORGE]: 'St.George',
  [LENDER.WESTPAC]: 'Westpac',
  [LENDER.WISR]: 'WISR',
  [LENDER.WISR_PL]: 'WISR PL',
  [LENDER.VOLKSWAGEN]: 'Volkswagen',
  [LENDER.BFS]: 'Branded Financial Services',
  [LENDER.AUTOPAY]: 'Autopay',
  [LENDER.PLENTI_C]: 'Plenti',
  [LENDER.AUTOPAY_C]: 'Autopay Commercial',
  [LENDER.LOAN_U]: 'LoanU',
  [LENDER.LOAN_U_PL]: 'LoanU PL',
  [LENDER.MONEYME_PL]: 'MoneyMe',
  [LENDER.GREEN_LIGHT_AUTO]: 'Green Light Auto',
  [LENDER.CAR_START]: 'Car Start',
  [LENDER.MEDFIN]: 'Medfin',
  [LENDER.AMMF]: 'AMMF',
  [LENDER.LATITUDE_PL]: 'Latitude PL',
  [LENDER.OUR_MONEY_MARKET_PL]: 'Our Money Market PL',
  [LENDER.OUR_MONEY_MARKET_RO_PL]: 'Our Money Market RO PL',
  [LENDER.OUR_MONEY_MARKET_SECURED]: 'Our Money Market Secured',
  [LENDER.AFFORDABLE_CAR_LOANS]: 'Affordable Car Loans',
  [LENDER.ALEX_BANK]: 'Alex Bank',
  [LENDER.ALEX_BANK_SECURED]: 'Alex Bank Secured',
  [LENDER.FINANCE_ONE_PLATINUM]: 'Finance One Platinum',
  [LENDER.FAIR_GO_FINANCE]: 'Fair Go Finance',
  [LENDER.SALT_AND_LIME]: 'Salt & Lime',
  [LENDER.METRO_CONSUMER]: 'Metro Consumer',
  [LENDER.SALT_AND_LIME_SECURED]: 'Salt & Lime Secured',
  [LENDER.RAPID_LOANS_PL]: 'Rapid Loans',
  [LENDER.JACARANDA_PL]: 'Jacaranda',
  [LENDER.RAPID_LOANS]: 'Rapid Loans',
  [LENDER.AFS_VYRO]: 'AFS Vyro',
  [LENDER.CREDIT24_PL]: 'Credit 24',
  [LENDER.METRO_NOVATED]: 'Metro Novated',
  [LENDER.AVANTI_FINANCE_PL]: 'Avanti Finance PL',
  [LENDER.HEARTLAND_BANK]: 'Heartland Bank',
  [LENDER.UDC_FINANCE]: 'UDC Finance',
  [LENDER.GEM_BY_LATITUDE]: 'Gem by Latitude',
  [LENDER.FINANCE_NOW]: 'Finance Now',
  [LENDER.FINANCE_NOW_PL]: 'Finance Now PL',
  [LENDER.AZORA_COMMERCIAL]: 'Azora Commercial',
  [LENDER.RESIMAC_COMMERCIAL]: 'Resimac Commercial',
  [LENDER.PLENTI_RO_PL_FIXED]: 'Plenti RO PL Fixed',
  [LENDER.LATITUDE_RO_PL]: 'Latitude RO PL',
  [LENDER.FAIR_GO_FINANCE_RO_PL]: 'Fair Go Finance RO PL',
  [LENDER.CFS]: 'CFS',
  [LENDER.GENEVA_FINANCE]: 'Geneva Finance',
  [LENDER.GENEVA_FINANCE_PL]: 'Geneva Finance PL',
  [LENDER.AVANTI_FINANCE]: 'Avanti Finance',
  [LENDER.FHL]: 'FHL',
  [LENDER.FHL_COMMERCIAL]: 'FHL Commercial',
  [LENDER.FHL_PL]: 'FHL PL',
  [LENDER.UDC_FINANCE_COMMERCIAL]: 'UDC Finance Commercial',
  [LENDER.AVANTI_FINANCE_COMMERCIAL]: 'Avanti Finance Commercial',
  [LENDER.HEARTLAND_BANK_COMMERCIAL]: 'Heartland Commercial',
  [LENDER.LUMI_COMMERCIAL]: 'Lumi Commercial',
  [LENDER.FINANCE_ONE_PLUS]: 'Finance One Plus',
  [LENDER.MTF_FINANCE]: 'MTF Finance',
  [LENDER.OXFORD_FINANCE]: 'Oxford Finance',
  [LENDER.HEARTLAND_PL]: 'Heartland PL',
  [LENDER.TRUEPILLARS_COMMERCIAL]: 'Truepillars Commercial',
  [LENDER.FINANCE_ONE_PLUS_COMMERCIAL]: 'Finance One Plus Commercial',
  [LENDER.SELFCO_COMMERCIAL]: 'Selfco Commercial',
  [LENDER.REVOLUT_RO_PL]: 'Revolut RO PL',
  [LENDER.PLENTI_RO_PL_VARIABLE]: 'Plenti RO PL Variable',
  [LENDER.WISR_RO_PL]: 'Wisr RO PL',
  [LENDER.DRIVA_NOVATED]: 'Driva Novated',
  [LENDER.MONEYME_PL_PAYSLIP_ONLY]: 'MoneyMe PL Payslip Only',
  [LENDER.LIBERTY_NOVATED]: 'Liberty Novated',
  [LENDER.THE_ASSET_FINANCIER_CONSUMER]: 'The Asset Financier (Allied)',
  [LENDER.THE_ASSET_FINANCIER_COMMERCIAL]: 'The Asset Financier (Allied) Commercial',
  [LENDER.MONEYME_RO_PL]: 'MoneyMe RO PL',
  [LENDER.ADVANTAGE_FINANCE]: 'Advantage Finance',
  [LENDER.GO_CAR_CREDIT]: 'Go Car Credit',
  [LENDER.DYNA_MONEY]: 'DynaMoney',
  [LENDER.ALLIED_NOVATED]: 'Allied Novated',
  [LENDER.ANGLE_AUTO]: 'Angle Auto',
  [LENDER.OXFORD_COMMERCIAL]: 'Oxford Commercial',
  [LENDER.MORRIS_FINANCE_COMMERCIAL]: 'Morris Finance Commercial',
  [LENDER.BIZCAP_COMMERCIAL]: 'Bizcap Commercial',
  [LENDER.OXFORD_PL]: 'Oxford PL',
  [LENDER.GAMMA_DUO]: 'Gamma Duo',
  [LENDER.GAMMA_DUO_PL]: 'Gamma Duo PL',
  [LENDER.JACARANDA_RO_PL]: 'Jacaranda RO PL',
  [LENDER.ALEX_BANK_RO]: 'Alex Bank RO',
  [LENDER.ALEX_BANK_RO_PL]: 'Alex Bank RO PL',
  [LENDER.AUTO_FINANCE_DIRECT]: 'Auto Finance Direct',
  [LENDER.HARMONEY]: 'Harmoney',
}

export const LenderToOfferMap = {
  [LENDER.VOLKSWAGEN]: 'bT4x42QcY5',
  [LENDER.BFS]: 'fT4x48QcY7',
  [LENDER.ANGLE]: 'is6I365uCH',
  [LENDER.ANGLE_NOVATED]: 'iP3758KtIE',
  [LENDER.ANZ]: 'aPRn8iY2O0',
  [LENDER.FINANCE_ONE]: 'Az3YDHse0A',
  [LENDER.FINANCE_ONE_C]: 'dzKGYHse0V',
  [LENDER.FINANCE_ONE_PL]: 'rZM8cNNz66',
  [LENDER.FIRST_MAC]: 'OlTG1D1duY',
  [LENDER.SHIFT_COMMERCIAL]: '2vJt0g7HEz',
  [LENDER.GROW]: 'Oyy1tfaR8L',
  [LENDER.GROW_CONSUMER]: '3yO0eeFq43',
  [LENDER.LATITUDE]: 'f8mMpX74V8',
  [LENDER.LIBERTY]: 'X1L1y4JeEd',
  [LENDER.LIBERTY_C]: 'UV9ha32YFK',
  [LENDER.MACQUARIE]: 'mC24vZk133',
  [LENDER.MACQUARIE_C]: 'emg5SLYv5h',
  [LENDER.METRO]: 'v53tLO8QQg',
  [LENDER.MONEY_THREE]: 'qGJshSoAjl',
  [LENDER.MONEY_THREE_PL]: '76bkvefz1T',
  [LENDER.MONEY_PLACE]: 'fd9aR68Yxi',
  [LENDER.MONEY_PLACE_PL]: 'a87Gaks8f7',
  [LENDER.NOW_FINANCE]: 'm6iE8b4MqL',
  [LENDER.NOW_FINANCE_PL]: 'jmcB55yOS4',
  [LENDER.NOW_FINANCE_RO_PL]: 'L7IAvFnYfs',
  [LENDER.PEPPER]: 'QB67dG9meu',
  [LENDER.PEPPER_C]: 'p775l2K6Mw',
  [LENDER.PROSPA]: 'J0Zul3cv9o',
  [LENDER.RATE_SETTER]: 'bCn3AoOa0w',
  [LENDER.RATE_SETTER_PL]: 'b6eNE0u2kG',
  [LENDER.SOCIETY_ONE]: 't2RWwThRe8',
  [LENDER.WESTPAC]: 'vD29PCatS7',
  [LENDER.WISR]: 'Y0fEMThmvQ',
  [LENDER.WISR_PL]: 'iJmGjG4wfO',
  [LENDER.AUTOPAY]: 'nXk7tz10Ec',
  [LENDER.PLENTI_C]: '2t3jrG69kF',
  [LENDER.AUTOPAY_C]: 'e7yaQQT2ZL',
  [LENDER.LOAN_U]: '6r2hrG96sB',
  [LENDER.LOAN_U_PL]: 'f876ghJHGF',
  [LENDER.MONEYME_PL]: 'Vmv8sfu6Du',
  [LENDER.GREEN_LIGHT_AUTO]: '34oRO67cod',
  [LENDER.CAR_START]: '0YdxZ8O0bk',
  [LENDER.MEDFIN]: 'kJ3X0G636e',
  [LENDER.AMMF]: 'up5WG646Ck',
  [LENDER.LATITUDE_PL]: 'dkK9UxP05O',
  [LENDER.OUR_MONEY_MARKET_PL]: 'bkA9U7vY7n',
  [LENDER.OUR_MONEY_MARKET_RO_PL]: 'e5jJnibFY5',
  [LENDER.OUR_MONEY_MARKET_SECURED]: 'ffA6U3vY7a',
  [LENDER.AFFORDABLE_CAR_LOANS]: '5muWB5C5vB',
  [LENDER.ALEX_BANK]: '43h7Th5TGQ',
  [LENDER.FINANCE_ONE_PLATINUM]: '3znEgbae8n',
  [LENDER.FAIR_GO_FINANCE]: '6cH3MB863q',
  [LENDER.SALT_AND_LIME]: 'zeB4JeSJ8R',
  [LENDER.METRO_CONSUMER]: 'cHAMPjj86w',
  [LENDER.SALT_AND_LIME_SECURED]: 'dV4QHsqbD4',
  [LENDER.RAPID_LOANS_PL]: 'ax8wZu52Uv',
  [LENDER.JACARANDA_PL]: 'w878TJa3cy',
  [LENDER.RAPID_LOANS]: 'ux8wZb52Uc',
  [LENDER.AFS_VYRO]: '9w2tfExjSe',
  [LENDER.AFS]: '02JSNoMeC0',
  [LENDER.ALEX_BANK_SECURED]: 'x759HWyNVE',
  [LENDER.CREDIT24_PL]: '38kmnt7cag',
  [LENDER.METRO_NOVATED]: '8uaqgqqPdR',
  [LENDER.AVANTI_FINANCE_PL]: 'PZkTsbrT26',
  [LENDER.HEARTLAND_BANK]: 'zABhjz9EkH',
  [LENDER.UDC_FINANCE]: 'KX75sFsvJz',
  [LENDER.GEM_BY_LATITUDE]: 'GfU5fd7zzh',
  [LENDER.FINANCE_NOW]: 'ZZpSUJfzNv',
  [LENDER.FINANCE_NOW_PL]: 'svJyjMMnTd',
  [LENDER.AZORA_COMMERCIAL]: 'hkbCM0eAX3',
  [LENDER.RESIMAC_COMMERCIAL]: 'j3aX0v5efg',
  [LENDER.PLENTI_RO_PL_FIXED]: 'ghy6QSb624',
  [LENDER.LATITUDE_RO_PL]: 'xYORM8Fq2X',
  [LENDER.FAIR_GO_FINANCE_RO_PL]: 'k8Ko8RJYiR',
  [LENDER.CFS]: '6qMqI7qtEK',
  [LENDER.GENEVA_FINANCE]: 'PQ4qgcV8aR',
  [LENDER.GENEVA_FINANCE_PL]: 'L09giNXuUM',
  [LENDER.AVANTI_FINANCE]: 'zmSPKS2I3R',
  [LENDER.FHL]: 'gP3qY9mZ2x',
  [LENDER.FHL_COMMERCIAL]: 'gHx9mSXaMi',
  [LENDER.FHL_PL]: '6mM2MyUwf4',
  [LENDER.UDC_FINANCE_COMMERCIAL]: 'JJ6RczmOdu',
  [LENDER.AVANTI_FINANCE_COMMERCIAL]: 'AY6gvAWS3M',
  [LENDER.HEARTLAND_BANK_COMMERCIAL]: '7qL4UfHrjm',
  [LENDER.LUMI_COMMERCIAL]: '4Gxy0hbNmX',
  [LENDER.FINANCE_ONE_PLUS]: 'Rojq42kAcz',
  [LENDER.MTF_FINANCE]: 'nMbSm7a7lc',
  [LENDER.OXFORD_FINANCE]: 'jNT6vQOV6T',
  [LENDER.HEARTLAND_PL]: 'nT46aBqBT1',
  [LENDER.TRUEPILLARS_COMMERCIAL]: 'RAu63YzShC',
  [LENDER.FINANCE_ONE_PLUS_COMMERCIAL]: 'ySx1cSMFye',
  [LENDER.SELFCO_COMMERCIAL]: 'G53cQ4csQJ',
  [LENDER.REVOLUT_RO_PL]: 'iV8SiXH8mE',
  [LENDER.PLENTI_RO_PL_VARIABLE]: '76mjpBNUjg',
  [LENDER.WISR_RO_PL]: 'FMKzqaG3ii',
  [LENDER.DRIVA_NOVATED]: 'vilg3Dh7as',
  [LENDER.MONEYME_PL_PAYSLIP_ONLY]: 'E8UKZobMFN',
  [LENDER.LIBERTY_NOVATED]: 'oplRC6Vthz',
  [LENDER.THE_ASSET_FINANCIER_CONSUMER]: '36zYmh2fXE',
  [LENDER.THE_ASSET_FINANCIER_COMMERCIAL]: '937JbTLkR3',
  [LENDER.MONEYME_RO_PL]: 'bunoPxT0Ge',
  [LENDER.ADVANTAGE_FINANCE]: 'NDqZahSZJK',
  [LENDER.GO_CAR_CREDIT]: 'BeDXPbHFvi',
  [LENDER.DYNA_MONEY]: '2IRWYf17Xw',
  [LENDER.ALLIED_NOVATED]: 'H3qZp7LwV9',
  [LENDER.ANGLE_AUTO]: 'y8rJ4Dqp30',
  [LENDER.OXFORD_COMMERCIAL]: 'S0drhFUf5Q',
  [LENDER.MORRIS_FINANCE_COMMERCIAL]: 'dbBLzAfWwG',
  [LENDER.BIZCAP_COMMERCIAL]: 'DQqAa2AFtP',
  [LENDER.OXFORD_PL]: 'jdMJnW3R4U',
  [LENDER.GAMMA_DUO]: 'hS0dRUHZcH',
  [LENDER.GAMMA_DUO_PL]: 'IxOfN0YuFI',
  [LENDER.JACARANDA_RO_PL]: 'z84vT0uUdu',
  [LENDER.ALEX_BANK_RO]: 'nKDBjaQlC7',
  [LENDER.ALEX_BANK_RO_PL]: 'gaSly1EHQY',
  [LENDER.AUTO_FINANCE_DIRECT]: 'YBmgQBWF9A',
  [LENDER.HARMONEY]: '53ejVoEo7s',
}

export const OfferIdToLenderMap = {
  ['is6I365uCH']: LENDER.ANGLE,
  ['iP3758KtIE']: LENDER.ANGLE_NOVATED,
  ['aPRn8iY2O0']: LENDER.ANZ,
  ['Az3YDHse0A']: LENDER.FINANCE_ONE,
  ['dzKGYHse0V']: LENDER.FINANCE_ONE_C,
  ['rZM8cNNz66']: LENDER.FINANCE_ONE_PL,
  ['OlTG1D1duY']: LENDER.FIRST_MAC,
  ['2vJt0g7HEz']: LENDER.SHIFT_COMMERCIAL,
  ['Oyy1tfaR8L']: LENDER.GROW,
  ['3yO0eeFq43']: LENDER.GROW_CONSUMER,
  ['f8mMpX74V8']: LENDER.LATITUDE,
  ['X1L1y4JeEd']: LENDER.LIBERTY,
  ['UV9ha32YFK']: LENDER.LIBERTY_C,
  ['mC24vZk133']: LENDER.MACQUARIE,
  ['emg5SLYv5h']: LENDER.MACQUARIE_C,
  ['v53tLO8QQg']: LENDER.METRO,
  ['qGJshSoAjl']: LENDER.MONEY_THREE,
  ['76bkvefz1T']: LENDER.MONEY_THREE_PL,
  ['fd9aR68Yxi']: LENDER.MONEY_PLACE,
  ['a87Gaks8f7']: LENDER.MONEY_PLACE_PL,
  ['m6iE8b4MqL']: LENDER.NOW_FINANCE,
  ['jmcB55yOS4']: LENDER.NOW_FINANCE_PL,
  ['L7IAvFnYfs']: LENDER.NOW_FINANCE_RO_PL,
  ['QB67dG9meu']: LENDER.PEPPER,
  ['p775l2K6Mw']: LENDER.PEPPER_C,
  ['J0Zul3cv9o']: LENDER.PROSPA,
  ['bCn3AoOa0w']: LENDER.RATE_SETTER,
  ['b6eNE0u2kG']: LENDER.RATE_SETTER_PL,
  ['t2RWwThRe8']: LENDER.SOCIETY_ONE,
  ['vD29PCatS7']: LENDER.WESTPAC,
  ['Y0fEMThmvQ']: LENDER.WISR,
  ['iJmGjG4wfO']: LENDER.WISR_PL,
  ['bT4x42QcY5']: [LENDER.VOLKSWAGEN],
  ['fT4x48QcY7']: [LENDER.BFS],
  ['nXk7tz10Ec']: [LENDER.AUTOPAY],
  ['2t3jrG69kF']: [LENDER.PLENTI_C],
  ['e7yaQQT2ZL']: [LENDER.AUTOPAY_C],
  ['6r2hrG96sB']: [LENDER.LOAN_U],
  ['f876ghJHGF']: [LENDER.LOAN_U_PL],
  ['Vmv8sfu6Du']: [LENDER.MONEYME_PL],
  ['34oRO67cod']: [LENDER.GREEN_LIGHT_AUTO],
  ['0YdxZ8O0bk']: [LENDER.CAR_START],
  ['kJ3X0G636e']: [LENDER.MEDFIN],
  ['up5WG646Ck']: [LENDER.AMMF],
  ['dkK9UxP05O']: [LENDER.LATITUDE_PL],
  ['bkA9U7vY7n']: [LENDER.OUR_MONEY_MARKET_PL],
  ['e5jJnibFY5']: [LENDER.OUR_MONEY_MARKET_RO_PL],
  ['ffA6U3vY7a']: [LENDER.OUR_MONEY_MARKET_SECURED],
  ['5muWB5C5vB']: [LENDER.AFFORDABLE_CAR_LOANS],
  ['43h7Th5TGQ']: [LENDER.ALEX_BANK],
  ['3znEgbae8n']: [LENDER.FINANCE_ONE_PLATINUM],
  ['6cH3MB863q']: [LENDER.FAIR_GO_FINANCE],
  ['zeB4JeSJ8R']: [LENDER.SALT_AND_LIME],
  ['cHAMPjj86w']: [LENDER.METRO_CONSUMER],
  ['dV4QHsqbD4']: [LENDER.SALT_AND_LIME_SECURED],
  ['ax8wZu52Uv']: [LENDER.RAPID_LOANS_PL],
  ['w878TJa3cy']: [LENDER.JACARANDA_PL],
  ['ux8wZb52Uc']: [LENDER.RAPID_LOANS],
  ['9w2tfExjSe']: [LENDER.AFS_VYRO],
  ['02JSNoMeC0']: [LENDER.AFS],
  ['x759HWyNVE']: [LENDER.ALEX_BANK_SECURED],
  ['38kmnt7cag']: [LENDER.CREDIT24_PL],
  ['8uaqgqqPdR']: [LENDER.METRO_NOVATED],
  ['PZkTsbrT26']: [LENDER.AVANTI_FINANCE_PL],
  ['zABhjz9EkH']: [LENDER.HEARTLAND_BANK],
  ['KX75sFsvJz']: [LENDER.UDC_FINANCE],
  ['GfU5fd7zzh']: [LENDER.GEM_BY_LATITUDE],
  ['ZZpSUJfzNv']: [LENDER.FINANCE_NOW],
  ['svJyjMMnTd']: [LENDER.FINANCE_NOW_PL],
  ['hkbCM0eAX3']: [LENDER.AZORA_COMMERCIAL],
  ['j3aX0v5efg']: [LENDER.RESIMAC_COMMERCIAL],
  ['ghy6QSb624']: [LENDER.PLENTI_RO_PL_FIXED],
  ['xYORM8Fq2X']: [LENDER.LATITUDE_RO_PL],
  ['k8Ko8RJYiR']: [LENDER.FAIR_GO_FINANCE_RO_PL],
  ['6qMqI7qtEK']: [LENDER.CFS],
  ['PQ4qgcV8aR']: [LENDER.GENEVA_FINANCE],
  ['L09giNXuUM']: [LENDER.GENEVA_FINANCE_PL],
  ['zmSPKS2I3R']: [LENDER.AVANTI_FINANCE],
  ['gP3qY9mZ2x']: [LENDER.FHL],
  ['gHx9mSXaMi']: [LENDER.FHL_COMMERCIAL],
  ['6mM2MyUwf4']: [LENDER.FHL_PL],
  ['JJ6RczmOdu']: [LENDER.UDC_FINANCE_COMMERCIAL],
  ['AY6gvAWS3M']: [LENDER.AVANTI_FINANCE_COMMERCIAL],
  ['7qL4UfHrjm']: [LENDER.HEARTLAND_BANK_COMMERCIAL],
  ['4Gxy0hbNmX']: [LENDER.LUMI_COMMERCIAL],
  ['Rojq42kAcz']: [LENDER.FINANCE_ONE_PLUS],
  ['nMbSm7a7lc']: [LENDER.MTF_FINANCE],
  ['jNT6vQOV6T']: [LENDER.OXFORD_FINANCE],
  ['nT46aBqBT1']: [LENDER.HEARTLAND_PL],
  ['RAu63YzShC']: [LENDER.TRUEPILLARS_COMMERCIAL],
  ['ySx1cSMFye']: [LENDER.FINANCE_ONE_PLUS_COMMERCIAL],
  ['G53cQ4csQJ']: [LENDER.SELFCO_COMMERCIAL],
  ['iV8SiXH8mE']: [LENDER.REVOLUT_RO_PL],
  ['76mjpBNUjg']: [LENDER.PLENTI_RO_PL_VARIABLE],
  ['FMKzqaG3ii']: [LENDER.WISR_RO_PL],
  ['vilg3Dh7as']: [LENDER.DRIVA_NOVATED],
  ['E8UKZobMFN']: [LENDER.MONEYME_PL_PAYSLIP_ONLY],
  ['oplRC6Vthz']: [LENDER.LIBERTY_NOVATED],
  ['36zYmh2fXE']: [LENDER.THE_ASSET_FINANCIER_CONSUMER],
  ['937JbTLkR3']: [LENDER.THE_ASSET_FINANCIER_COMMERCIAL],
  ['bunoPxT0Ge']: [LENDER.MONEYME_RO_PL],
  ['NDqZahSZJK']: [LENDER.ADVANTAGE_FINANCE],
  ['BeDXPbHFvi']: [LENDER.GO_CAR_CREDIT],
  ['2IRWYf17Xw']: [LENDER.DYNA_MONEY],
  ['H3qZp7LwV9']: [LENDER.ALLIED_NOVATED],
  ['y8rJ4Dqp30']: [LENDER.ANGLE_AUTO],
  ['S0drhFUf5Q']: [LENDER.OXFORD_COMMERCIAL],
  ['dbBLzAfWwG']: [LENDER.MORRIS_FINANCE_COMMERCIAL],
  ['DQqAa2AFtP']: [LENDER.BIZCAP_COMMERCIAL],
  ['jdMJnW3R4U']: [LENDER.OXFORD_PL],
  ['hS0dRUHZcH']: [LENDER.GAMMA_DUO],
  ['IxOfN0YuFI']: [LENDER.GAMMA_DUO_PL],
  ['z84vT0uUdu']: [LENDER.JACARANDA_RO_PL],
  ['nKDBjaQlC7']: [LENDER.ALEX_BANK_RO],
  ['gaSly1EHQY']: [LENDER.ALEX_BANK_RO_PL],
  ['YBmgQBWF9A']: [LENDER.AUTO_FINANCE_DIRECT],
  ['53ejVoEo7s']: [LENDER.HARMONEY],
}
